exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-form-new-business-unit-component .content-btns{margin-top:1.4rem}", ""]);

// exports
